// THIS FILE WAS AUTO GENERATED, UPDATE THE i18n FILES

import { HBinput, i18nLoad } from "@cervval.js/i18n/src/i18n.tools";

export type I18nType = {
    loginButton: {
        innerHTML: string
    },
    loginInProgress: string,
    loginInput: {
        placeholder: string
    },
    passwordInput: {
        placeholder: string
    }
};

const i18n_en = require("./_en.i18n"); // hash_en=156657298266375#
const i18n_fr = require("./_fr.i18n"); // hash_fr=5318100631839112#

/** @returns the i18n for provided lang (fallback on app.lang if i18n not found for lang) */
export function i18n(lang?: string): I18nType {
    return i18nLoad<I18nType>(lang, ["en", "fr"], (langToLoad: string) => {
        switch (langToLoad) {
            case "en": return i18n_en;
            case "fr": return i18n_fr;
            default:
        }
        return null;
    });
}